import React, { useState } from "react";
import { Card, Button, Container, Row, Col, Form } from "react-bootstrap";
import { FaCheckCircle, FaCheck, FaMinus,  FaPaypal, FaMoneyCheckAlt } from "react-icons/fa"; // All icons imported
import "./Card.css";

const Cards = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPayment, setShowPayment] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("paypal");
  const [userData, setUserData] = useState({ name: "", email: "" });
  const [duration, setDuration] = useState(1); // Default duration is 1 month



  const plans = [
    {
      price: "99",
      billing: "Basic Plan",
      description:
        "The best way to grow quickly and with more advanced targeting. Ideal for fast-growing influencers and brands.",
      buttonText: "$3.30 Per Day",
      features: [
        "2,500 - 3,500 Followers /mo",
        "Follower Growth Within 2 Days",
        "Guaranteed Results Or It's Free",
        "Los Angeles Team & Support",
        "Engaged, Organic Followers",
        "Hands Off For You",
        "Advanced AI Targeting",
        "Dedicated 24/7 Support",
      ],
      // stripeLink: "https://buy.stripe.com/4gw6qf5BgcfebksdRK", // Stripe link for Basic Plan
    },
    {
      price: "149",
      billing: "Elite Plan",
      description:
        "Ideal for businesses looking for rapid audience growth with real engagement and targeted strategy.",
      buttonText: "$4.97 Per Day",
      features: [
        "5,000 - 7,000 Followers /mo",
        "Priority Growth & Engagement",
        "Dedicated Account Manager",
        "Targeted Follower Strategy",
        "Brand Consultation Included",
        "Hands Off For You",
        "Advanced AI Targeting",
        "24/7 VIP Support",
      ],
      // stripeLink: "https://buy.stripe.com/cN2bKz7Joenm6089Bl", // Stripe link for Elite Plan
    },
    {
      price: "199",
      billing: "Premium Plan",
      description:
        "The ultimate plan for brands and influencers who want the fastest and most effective growth strategy.",
      buttonText: "$6.63 Per Day",
      features: [
        "10,000+ Followers /mo",
        "Maximum Engagement",
        "Personalized Growth Plan",
        "Expert Strategy Calls",
        "Exclusive AI Targeting",
        "Hands Off For You",
        "Organic Audience Growth",
        "Dedicated 24/7 VIP Support",
      ],
      // stripeLink: "https://buy.stripe.com/eVaaGv1l0a76ewEbJj", // Stripe link for Premium Plan
    },
        // 2
        {
          price: "99",
          billing: " Engagement  Basic Plan",
          description:
            "The ultimate plan for brands and influencers who want the fastest and most effective growth strategy.",
          buttonText: "$3.30 Per Day",
          features: [
            "Let's increase your engagement upto 3% to 5% gradually step by step which will make your posts to get visible to your audience with lot of interactions in terms",
    
            "We focus and make sure that your profile will be pushed to the people of same interest..",
            "Same for location. We will target your locations and make sure that your each post will be pushed to explore page of your familiar locations.",
    
            "It would be  1500-2000 plus likes+ 30 plus comments + 15k -20k reels video views  on your each and every post and it cost for you 150$ for a month",
          ],
          
        },
    
        {
          price: "199",
          billing: " Engagement  Elite Plan",
          description:
            "The ultimate plan for brands and influencers who want the fastest and most effective growth strategy.",
          buttonText: "$6.63 Per Day",
          features: [
            "Let's increase your engagement upto 5% to 10% gradually step by step which will make your posts to get visible to your audience with lot of interactions in terms",
    
            "We focus and make sure that your profile will be pushed to the people of same interest..",
            "Same for location. We will target your locations and make sure that your each post will be pushed to explore page of your familiar locations.",
    
            "It would be  2500-3000 plus likes+ 30 plus comments + 20k -30k reels video views  on your each and every post and it cost for you 199$ for a months",
          ],
          
        },
    
        {
          price: "299",
          billing: " Engagement  Premium Plan",
          description:
            "The ultimate plan for brands and influencers who want the fastest and most effective growth strategy.",
          buttonText: "$9.97 Per Day",
          features: [
            "Let's increase your engagement upto 5% to 10% gradually step by step which will make your posts to get visible to your audience with lot of interactions in terms",
    
            "We focus and make sure that your profile will be pushed to the people of same interest..",
            "Same for location. We will target your locations and make sure that your each post will be pushed to explore page of your familiar locations.",
    
            "It would be  2500-3000 plus likes+ 30 plus comments + 20k -30k reels video views  on your each and every post and it cost for you 199$ for a months",
          ],
          
        },
  ];

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
    setShowPayment(true);
  };

  const handlePaymentSubmit = (userData, paymentMethod) => {
    const totalPrice = parseFloat(selectedPlan.price) * duration;

    let paymentLink = "";
    switch (paymentMethod) {
      case "paypal":
        paymentLink = `https://www.paypal.com/payment?amount=${totalPrice}&email=${userData.email}`; // Replace with your PayPal link
        break;
      
      case "revolut":
        paymentLink = `https://revolut.me/ioanayoyo/payment?amount=${totalPrice}&email=${userData.email}`; // Replace with your Revolut link
        break;
        case "stripe":
          paymentLink = "https://buy.stripe.com/4gw6qf5BgcfebksdRK";
          break;
      default:
        alert("Invalid payment method selected.");
        return;
    }

    // Redirect to Payment Gateway
    window.location.href = paymentLink;
  };

  return (
    <Container className="py-5 mt-5 pt-5 mb-5">
      <Row className="gy-4  mb-5">
        {plans.map((plan, index) => (
          <Col key={index} md={6} lg={4}>
            <Card className="border-black border-2 pricing-card border rounded shadow-sm position-relative text-center p-3">
              <div className="button-wrapper">
                <Button className="plan-button">{plan.buttonText}</Button>
              </div>

              <Card.Body className="pt-5">
                <h4 className="fw-bold">${plan.price}</h4>
                <p className="text-muted" id="billing">{plan.billing}</p>
                <p className="text-secondary">{plan.description}</p>
                <hr />

                <ul className="list-unstyled text-start px-3">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="d-flex align-items-center mb-2">
                      <FaCheckCircle className="text-success me-2" />
                      {feature}
                    </li>
                  ))}
                </ul>

                <Button variant="outline-primary" className="mt-3 viewbtn" onClick={() => handleSelectPlan(plan)}>
                  Get Started Now
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {showPayment && (
        <Container className="my-5" id="payment-section">
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card className="shadow">
                <Card.Body id="PaymentForm">
                  <h2 className="text-center mb-4">Payment Details</h2>
                  <Form onSubmit={(e) => {
                    e.preventDefault();
                    handlePaymentSubmit(userData, paymentMethod);
                  }}>
                    {/* User Details */}
                    <Form.Group className="mb-3">
                      <Form.Label></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your name"
                        required
                        value={userData.name}
                        onChange={(e) => setUserData({ ...userData, name: e.target.value })}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label></Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        required
                        value={userData.email}
                        onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                      />
                    </Form.Group>

                    {/* Duration Selection */}
                    <Form.Group className="mb-3 form1">
                      <Form.Label>Select Duration (Months)</Form.Label>
                      <Form.Select
                        value={duration}
                        onChange={(e) => setDuration(parseInt(e.target.value))} // Update duration state
                        required
                      >
                        <option value={1}>1 Month</option>
                        <option value={2}>2 Months</option>
                        <option value={3}>3 Months</option>
                        <option value={4}>4 Months</option>
                        <option value={5}>5 Months</option>
                        <option value={6}>6 Months</option>
                        <option value={12}>12 Months</option>
                      </Form.Select>
                    </Form.Group>

                    {/* Plan Details */}
                    <Card className="mb-3">
                      <Card.Body>
                        <p className="mb-1">
                          <strong>Selected Plan:</strong> {selectedPlan.billing}
                        </p>
                        <p className="mb-1">
                          <strong>Duration:</strong> {duration} month(s)
                        </p>
                        <p className="mb-0">
                          <strong>Total Amount:</strong> $
                          {(parseFloat(selectedPlan.price) * duration).toFixed(2)}
                        </p>
                      </Card.Body>
                    </Card>

                    {/* Payment Method */}
                    <Form.Group className="mb-4 form1">
                      <Form.Label>Select Payment Method</Form.Label>
                      <Form.Select
                        value={paymentMethod}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        required
                      >
                        <option value="paypal" className="form1">
                          <FaPaypal className="me-2" />
                          PayPal
                        </option>
                        <option value="revolut">
                          <FaMoneyCheckAlt className="me-2" />
                          Revolut
                        </option>
                        <option value="stripe">
                          Stripe
                        </option>
                      </Form.Select>
                    </Form.Group>

                    {/* Submit Button */}
                    <Button type="submit" variant="" className="w-100 proceedbtn">
                      Proceed to Payment
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}

      {/* Rest of your code remains unchanged */}
      {/* What's Included Section */}
      <Container className="py-5" id="cardClass">
        <Row className="gy-4">
          <Col md={6} className="text-start">
            <h2 className="heading text-white">What's Included</h2>
          </Col>
          <Col md={3} className="text-start">
            <h3 className="heading text-white">
              Core
              <hr className="text-white text-center" id="cardhr" />
            </h3>
          </Col>
          <Col md={3} className="text-start">
            <h3 className="heading text-white">
              Elite
              <hr className="text-white text-center" id="cardhr" />
            </h3>
          </Col>
        </Row>
      </Container>

      {/* Targeting Features Section */}
      <Container className="py-5 mt-4 targeting" id="cardClass2">
        <Row>
          <Col>
            <h3 className="targeting1 text-black px-5">Targeting Features</h3>
          </Col>
        </Row>
      </Container>

      {/* Feature Rows */}
      {[
        {
          title: "Influencer Shout-outs",
          description:
            "Based on your niche, targeting filters, and our AI Profile Review, we’ll regularly post shoutouts to your content from our 13,000+ influencers.",
        },
        {
          title: "Email Newsletters",
          description:
            "Based on your niche, targeting filters, and our AI Profile Review, we’ll include your content in our Daily Newsletters and Weekly Digests to 9MM+ subscribers.",
        },
        {
          title: "Relevant Hashtags",
          description:
            "Define relevant hashtags you want to target and we’ll find users who are interested in those specific categories.",
        },
        {
          title: "Activity Log",
          description:
            "Keep track of all the activity Path Social generates on your account, including shoutouts, newsletter sends, outreach, and much more.",
        },
        {
          title: "Real-Time Analytics",
          description:
            "Gain access to a comprehensive dashboard to analyze your follower growth, engagement, content, and so much more.",
        },
        {
          title: "Engagement Sources",
          description:
            "View top channels your profile visitors are coming from to determine the best sources of followers.",
        },
        {
          title: "Fusionsphere Advanced AI",
          description:
            "Gain exclusive features and insights to boost your Instagram growth.",
        },
        {
          title: "Manual Targeting Review",
          description:
            "In addition to Advanced AI targeting, our team will analyze your content, followers, engagement, comments, niche, and competitors to personalize your growth strategy.",
        },
        {
          title: "Ludicrous Growth",
          description:
            "Get 5-10x more shoutouts, email sends, and targeted audiences to maximize speed in your Instagram growth strategy.",
        },
        {
          title: "24/7 Premium Support",
          description:
            "Reach our Los Angeles based experts anytime, anywhere you prefer.",
        },
      ].map((feature, index) => (
        <Container key={index} className="py-4 mt-4 px-4 custom-container" id="cardClass2">
          <Row className="gy-4 align-items-center">
            <Col md={6}>
              <h3>{feature.title}</h3>
              <p className="text-secondary">{feature.description}</p>
            </Col>
            <Col md={3} className="text-center d-none d-md-block">
              <FaCheck className="icon1" />
            </Col>
            <Col md={3} className="text-center d-none d-md-block">
              <FaCheck className="icon1" />
            </Col>
            <Col xs={12} className="d-md-none text-center">
              <Row className="justify-content-center">
                <Col xs={4} className="text-center">
                  <p className="icon-text">Core</p>
                  <FaCheck className="icon1" />
                </Col>
                <Col xs={4} className="text-center">
                  <p className="icon-text">Elite</p>
                  <FaCheck className="icon1" />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      ))}

      {/* Elite Only Features Section */}
      <Container className="py-5 mt-4 targeting" id="cardClass2">
        <Row>
          <Col>
            <h3 className="targeting1 text-black px-5">Elite Only Features</h3>
          </Col>
        </Row>
      </Container>

      {/* Elite Feature Rows */}
      {[
        {
          title: "Dedicated Account Success Manager",
          description:
            "Every Elite profile is assigned to a dedicated senior Account Success Manager who leads the strategy for your Instagram growth.",
        },
        {
          title: "Growth Expert Insights",
          description:
            "Reach our specialized Instagram growth strategy team for insights and recommendations tailored to your account.",
        },
        {
          title: "Beta Features",
          description:
            "Be the first to access new features designed to help your organic Instagram growth.",
        },
        {
          title: "Fusionsphere Exclusive Invites",
          description:
            "Free invitations to Path Social seminars, webinars, and industry expert events to network, learn state of the art strategies, and learn industry secrets.",
        },
        {
          title: "Be a part of the family",
          description:
            "Every customer is a part of our family here at Path Social. Our mission is to help you grow, and we’ll go the length to get you there ❤️",
        },
      ].map((feature, index) => (
        <Container key={index} className="py-4 mt-4 px-4 custom-container" id="cardClass2">
          <Row className="gy-4 align-items-center">
            <Col md={6}>
              <h3>{feature.title}</h3>
              <p className="text-secondary">{feature.description}</p>
            </Col>
            <Col md={3} className="text-center d-none d-md-block">
              <FaMinus className="icon1" />
            </Col>
            <Col md={3} className="text-center d-none d-md-block">
              <FaCheck className="icon1" />
            </Col>
            <Col xs={12} className="d-md-none text-center">
              <Row className="justify-content-center">
                <Col xs={4} className="text-center">
                  <p className="icon-text">Core</p>
                  <FaMinus className="icon1" />
                </Col>
                <Col xs={4} className="text-center">
                  <p className="icon-text">Elite</p>
                  <FaCheck className="icon1" />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      ))}
    </Container>
  );
};

export default Cards;